var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.896,
    height: 17.797,
    viewBox: "0 0 31.896 17.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_statistic_1295342",
    transform: "translate(-22.8 -79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7249",
    "data-name": "Path 7249",
    d: "M51.437,79a3.268,3.268,0,0,0-3.259,3.259,3.149,3.149,0,0,0,.389,1.529L44.407,88.1a3.267,3.267,0,0,0-3.848.752L37.764,87.61a3.054,3.054,0,0,0,.013-.338,3.259,3.259,0,0,0-6.517,0,3.179,3.179,0,0,0,.175,1.04l-3.484,2.582a3.221,3.221,0,0,0-1.892-.614,3.259,3.259,0,1,0,3.259,3.259,3.179,3.179,0,0,0-.175-1.04l3.484-2.582a3.24,3.24,0,0,0,4.311-.464l2.795,1.241a3.054,3.054,0,0,0-.013.338,3.259,3.259,0,0,0,6.517,0,3.149,3.149,0,0,0-.389-1.529l4.161-4.311a3.192,3.192,0,0,0,1.429.326,3.259,3.259,0,0,0,0-6.517Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticIco);
export default __webpack_public_path__ + "static/media/statistic_ico.4721c48e.svg";
export { ForwardRef as ReactComponent };